import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import * as React from 'react';

function ProjectTemplateCard(props) {
  return (
    <div className="flex cursor-pointer flex-row flex-nowrap rounded-[8px] border-b-2 hover:bg-[#f2f2f2]">
      <Stack>
        <CardContent>
          <Typography gutterBottom variant="subtitle2" component="div">
            {props.template.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {props.template.default_message}
          </Typography>
        </CardContent>
      </Stack>
    </div>
  );
}

export default ProjectTemplateCard;
